import React from 'react'
import { useTextResources } from '../../../language';
import { UserDefaultHomePage } from '../constants';
import DropDown from '../dropdown';

const DefaultHomePageDropDown = (props) => {
    const text = useTextResources()

    const dataSource = [
        { Code: UserDefaultHomePage.HomePage, Name: text("Homepage") },
        { Code: UserDefaultHomePage.Dashboard, Name: text("Dashboard") },
        { Code: UserDefaultHomePage.Calendar, Name: text("Calendar") },
        { Code: UserDefaultHomePage.LivePage, Name: text("OptimaLive") },
    ];

    return <DropDown data={dataSource} search spec={{ GetOnlyCustomerArray: true }} textField="Name" valueField="Code" {...props} />
}

export default DefaultHomePageDropDown
